<template>
     <!-- toast -->
  <AlertMsg :msg="msgObj.msg" :show="msgObj.show" :role="msgObj.role" @closePopup="msgObj.show = false"></AlertMsg>
  <!-- end toast -->
  <!-- toast -->
  <div v-if="showMessage" class="toast align-items-center text-bg-success fade show position-fixed top-0 end-0"
    role="alert" aria-live="assertive" aria-atomic="true" data-config='{"delay":5000, "autohide":true}' style="z-index:9999;">
    <div class="d-flex">
      <div class="toast-body">Teacher Added Successfuly.</div>
      <button type="button" class="btn-close me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
    </div>
  </div>
  <!-- end toast -->
  <div class="row">
    <div class="col-12">
      <div class=" d-flex align-items-center mt-2">
       
        <h5 class="mb-0 text-primary"> <i class="fa fa-chalkboard-teacher text-primary"></i> Add Teacher</h5>
      </div>
      <hr>
      <div class="row g-3">
        <div class="col-md-3">
          <label class="form-label">Name<sup><span class="text-danger font-12">*</span></sup> :</label>
          <input type="text" class="form-control form-control-sm" v-model="teacher.Name">
        </div>
        <div class="col-md-3">
          <label class="form-label">Email<sup><span class="text-danger font-12">*</span></sup> :</label>
          <input type="email" class="form-control form-control-sm" v-model="teacher.Email">
           <span v-if="errors.Email" class="text-danger font-12">{{ errors.Email }}</span>
        </div>
        <div class="col-md-3">
          <label class="form-label">Password<sup><span class="text-danger font-12">*</span></sup> :</label>
         <div class="input-group input-group-sm">
              <input :type="showPassword ? 'text' : 'password'" class="form-control form-control-sm" id="inputPassword" v-model="teacher.Password" />
            <span class="input-group-text cursor-pointer bg-white" role="button" @click="togglePassword">
      <i :class="['fa', showPassword ? 'fa-eye' : 'fa-eye-slash' ]"></i>
         </span></div>
         </div>
        <div class="col-md-3">
          <label class="form-label">Phone<sup><span class="text-danger font-12">*</span></sup> :</label>
          <input type="number" class="form-control form-control-sm" @input="limitDigits($event, 10, v => teacher.Phone = v)" v-model="teacher.Phone">
        </div>
        <div class="col-md-3">
            <label class="form-label">Gender<sup><span class="text-danger font-12">*</span></sup> :</label>
            <div class="row col-md-12 mt-1 ml-15">
              <div class="form-check radio-inline col-md-4">
                <input class="form-check-input border-dark" type="radio" name="gender" value="Male" v-model="teacher.Gender"
                  id="maleCheck" />
                <label class="form-check-label" for="maleCheck">M</label>
              </div>
              <div class="form-check radio-inline col-md-4">
                <input class="form-check-input border-dark" type="radio" name="gender" value="Female" v-model="teacher.Gender"
                  id="femaleCheck" />
                <label class="form-check-label" for="femaleCheck">F</label>
              </div>
              <div class="form-check radio-inline col-md-4">
                <input class="form-check-input border-dark" type="radio" name="gender" value="Other" v-model="teacher.Gender"
                  id="otherCheck" />
                <label class="form-check-label" for="otherCheck">Other</label>
              </div>
            </div>
          </div>

        <div class="col-md-3">
          <label class="form-label">Blood Group :</label>
          <select class="form-select form-select-sm rounded cursor-pointer" role="button" v-model="teacher.BloodGroup">
            <option selected value=""></option>
            <option v-for="(blood, i) in BloodGroups" :key="i" :value="blood">{{ blood }}</option>
          </select>
        </div>
        <div class="col-md-3">
          <label class="form-label">Address<sup><span class="text-danger font-12">*</span></sup> :</label>
          <input type="text" class="form-control form-control-sm" v-model="teacher.Address">

        </div>
        <div class="col-md-3">
          <label class="form-label">About :</label>
          <input type="text" class="form-control form-control-sm" v-model="teacher.About">
        </div>
        <div class="col-md-3">
          <label class="form-label">Department<sup><span class="text-danger font-12">*</span></sup> :</label>
          <input class="form-control form-control-sm" type="text" v-model="teacher.Department">
        </div>
        <div class="col-md-3">
          <label class="form-label">Teaching Classes:</label>
          <input type="text" class="form-control form-control-sm" v-model="teacher.TeachingClasses">
        </div>
            <div class="col-md-3">
            <label class="form-label">
              Class Teacher :
            </label>
            <div class="dropdown">
              <button class="form-select form-select-sm rounded dropdown-toggle w-100 dropdown-a"  type="button" data-bs-toggle="dropdown" aria-expanded="false">
                {{ clsList.find(c => c._id === teacher.ClassTeacher)?.name || "" }}
              </button>
              <ul class="dropdown-menu w-100 scrollable-menu" >
                <li v-for="(item, index) in uniqueClsList" :key="index">
                  <a class="dropdown-item" href="#" @click.prevent="teacher.ClassTeacher = item._id"  >
                    {{ item.name }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        <div class=" col-md-3">
          <label for="inputclassname" class="form-label">Section :</label>
          <select class="form-select form-select-sm rounded cursor-pointer" role="button" id="inputclass" v-model="teacher.Section">
            <option selected=""></option>
            <option v-for="(item, index) in secList" :key="index" :value="item._id">
              {{ item.Name }}
            </option>
          </select>
        </div>
        <div class="col-md-3">
          <label class="form-label">Joining Date :</label>
          <input class="form-control form-control-sm" type="date" v-model="teacher.JoiningDate">
        </div>
        <div class="col-md-3">
          <label class="form-label">Date of Birth :</label>
          <input class="form-control form-control-sm" type="date" v-model="teacher.DOB">
        </div>
        <div class="col-md-3">
          <label class="form-label">Designation<sup><span class="text-danger font-12">*</span></sup> :</label>
          <input class="form-control form-control-sm" type="text" v-model="teacher.Designation">
        </div>
        <div class="col-md-3">
          <label class="form-label">Aadhaar Photo :</label>
          <label for="fileInput" class="attachment-icon" >
              <i class="fa fa-upload"></i>
            </label>
         <input class="form-control" id="fileInput" type="file" multiple accept=".png,.jpg,.jpeg,.webp,.pdf,.docx,.doc,.xls,.txt" @change="UploadImg" />
             <div class="d-flex align-items-start">
          <a :href="getUrl(teacher.Photo)" target="_blank"  class="clearfix">{{teacher.Photo.substring(teacher.Photo.lastIndexOf('/') + 1)  }} </a>
          <i role="button" v-if="teacher.Photo !== ''" @click="deleteFile(teacher.Photo, 'Photo')" class="fa-solid fa-x text-danger f-5 mt-2 ms-1"></i>
        </div></div>
        <div class="col-md-3">
          <label class="form-label">Profile Photo :</label>
           <label for="fileTransfer" class="attachment-icon" >
              <i class="fa fa-upload"></i>
            </label>
            <input class="form-control" id="fileTransfer" type="file" multiple accept=".png,.jpg,.jpeg,.webp,.pdf,.docx,.doc,.xls,.txt" @change="FileUploadImg" />
             <div class="d-flex align-items-start">
            <a :href="getUrl(teacher.Image)" target="_blank"  class="clearfix">{{teacher.Image?.substring(teacher.Image.lastIndexOf('/') + 1)  }} </a>
            <i role="button" v-if="teacher.Image !== ''" @click="deleteFile(teacher.Image, 'Image')" class="fa-solid fa-x text-danger f-5 mt-2 ms-1"></i>
        </div>
      </div>
        <div class="row">
          <div class="col-md-6">
           <div class="capture-a mt-2">
              <CapturePhoto :autoStart="true" :dwnloadfileName="'Teacher'"></CapturePhoto>
            </div>
            </div>
          <div class="col-md-6 text-end mt-2">
          <button class="btn btn-sm btn-darknavy me-1" @click="save()"><i
              class="fa fa-save"></i> Save</button>
           <button type="button" class="btn btn-sm btn-soft-dark" @click="reset()"><i class="fa fa-times-circle  me-1"></i> Cancel</button>
        </div>
        </div>
       <ul v-if="errors.length" class="text-danger ps-3">
        <li v-for="(err, index) in errors" :key="index">{{ err }}</li>
      </ul>
      </div>
    </div>
  </div>
</template>
<script setup>
import AlertMsg from "@/components/Common/AlertMsg.vue";
import { isRequired, validateForm,isEmail } from '@/utils/validation.js';
import CapturePhoto from "@/components/Common/CapturePhoto.vue";
import { useFileUpload } from '@/utils/fileUpload';
const { handleFileUploadImg } = useFileUpload()
import {api} from '@/utils/helpers.js';
import { ref, onMounted} from 'vue'
import { schoolStore } from '@/utils/schoolStore';
import { useRoute } from 'vue-router'
const { clsList,uniqueClsList, secList } = schoolStore();
const route = useRoute()
 const   msgObj= ref({ msg: "", role: "", show: false, })
 const EditMode = ref(false);
  const  teacher = ref( {  Name: "",
        Email: "",
        Password: "",
        Phone: "",
        Gender: "",
        BloodGroup: "",
        Address: "",
        About: "",
        Department: "",
        class:"",
        subject:"",
        ClassTeacher: "",
        Section: "",
        JoiningDate: new Date().toISOString().slice(0, 10),
        DOB: new Date().toISOString().slice(0, 10),
        Designation: "",
        Photo: "",
        Image: "", })
      const showPassword = ref(false)
      const  BloodGroups = ref(["A+", "A-", "O+", "O-", "AB+", "AB-", "B+", "B-"])
      const showMessage = ref(false)
  
    const   errors= ref({})
   const  togglePassword= ()=> {
  showPassword.value = !showPassword.value
    }
    const limitDigits = (event, max, assignFn) => {
  let val = event.target.value.toString().slice(0, max);
  assignFn(val.replace(/\D/g, ''));
}
    const loadDetails= async()=> {
      await api .get(`/teachers/` + route.query.id)
        .then((response) => {
          teacher.value = {
        ...teacher.value,
        ...response.data,
        DOB: response.data?.DOB ? new Date(response.data.DOB).toISOString().slice(0, 10) : "",
        JoiningDate: response.data?.JoiningDate ? new Date(response.data.JoiningDate).toISOString().slice(0, 10) : "",
        Password:'',
      };
       EditMode.value = true;
        });
    }

    const save= async()=> {
      const fields = {
        Name: { value: teacher.value.Name, validators: [isRequired], },
        Email: { value: teacher.value.Email, validators: [isRequired, isEmail], },
        PhoneNo: { value: teacher.value.Phone, validators: [ (v) => { if (!v) return "Phone Number is required"; if (v.length < 10) return "Phone Number must be 10 digits"; return null; }, ], },
        Gender: { value: teacher.value.Gender, validators: [isRequired], },
        Address: { value: teacher.value.Address, validators: [isRequired], },
        Department: { value: teacher.value.Department, validators: [isRequired], },
        Designation: { value: teacher.value.Designation, validators: [isRequired], },
      };
      if (!EditMode.value) {
    fields.Password = { value: teacher.value.Password, validators: [isRequired] };
  }
      errors.value = validateForm(fields);
      if (Object.keys(errors.value).length === 0) {
           if(route.query.id){
      await api.put(`/teachers/${route.query.id}`, teacher.value, { headers: { "Content-Type": "multipart/form-data", }, })
              .then((response) => {
                showMessage.value = true;
                 reset();
                console.log(response);
              })
              .catch((error) => { console.log(error); });
      } else {
      await api.post(`/teachers/add`, teacher.value, { headers: { "Content-Type": "multipart/form-data", }, })
              .then((response) => {
                 reset();
                showMessage.value = true;
                console.log(response);
              })
              .catch((error) => { console.log(error); });
      }
      }
    }
     const reset= async()=> {
      teacher.value = {
        Name: "",
        Email: "",
        Password: "",
        Phone: "",
        Gender: "",
        BloodGroup: "",
        Address: "",
        About: "",
        Department: "",
        class:"",
        subject:"",
        ClassTeacher: "",
        Section: "",
        JoiningDate: new Date().toISOString().slice(0, 10),
        DOB: new Date().toISOString().slice(0, 10),
        Designation: "",
        Photo: "",
        Image: "",
      };
      errors.value= {};
     EditMode.value = false;
    }
const UploadImg = async (event) => {
  const file = event.target.files[0];
  if (!file) return;
const { file: uploadedFile, message } = await handleFileUploadImg(file);
  if (message) {
    msgObj.value = { msg: message, role: "danger", show: true };
    event.target.value = ""; 
    return;
  }
  if (uploadedFile) { teacher.value.Photo = uploadedFile; }
  event.target.value = null;
};
const FileUploadImg = async (event) => {
  const file = event.target.files[0];
  if (!file) return;
const { file: uploadedFile, message } = await handleFileUploadImg(file);
  if (message) {
    msgObj.value = { msg: message, role: "danger", show: true };
    event.target.value = ""; 
    return;
  }
  if (uploadedFile) { teacher.value.Image = uploadedFile; }
  event.target.value = null;
}; 
const deleteFile = async (filePath, field) => {
  if (!filePath) return;
  const fileName = filePath.split('/').pop();
  try {
    await api.delete(`/documents/students?filename=${fileName}`);
    if (field === 'Photo') teacher.value.Photo = '';
    if (field === 'Image') teacher.value.Image = '';
  } catch (err) {
    console.error('Failed to delete file', err);
  }
};
    const getUrl= (img) => {
      let imgUrl = !img
        ? "/images/default.png"
        : img.startsWith("..")
          ? img.substring(2)
          : img;
      
  const base = process.env.VUE_APP_API_URL.replace(/\/+$/, "");
  const path = imgUrl.replace(/^\/+/, "");
  return `${base}/${path}`;
    }
 onMounted(() => { loadDetails() })
</script>
<style>
.cancelButton {
  border-radius: 7px;
  border: none;
  background-color: lightgray;
}

.input-group>span {
  width: 40%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: lightgray;
}

.input-flex-wrap {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  flex-wrap: wrap;
  gap: 10px;
}

.input-row {
  display: flex;
  flex: 0 0 calc(40% - 20px);
}
.class-dropdown {
  max-height: 150px;  
  overflow-y: auto;   
}
.input-row input {
  flex: 1;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
</style>